import { selector } from "recoil";
import { memoize } from "../utils";
import { protocol } from "../utils/api";

export const ProtocolSelector = memoize((slug: string) => selector({
  key: 'Protocol ' + slug,
  get: async () => {
    return await protocol(slug);
  }
}));